import { GraphQLResponse, MenuEntity, ReactBlockPageEntity } from "../../Components/processors";
import { GET_ALL_MENU_PARAMS, GET_REACT_BLOCK_PAGE_PARAMS } from "../../Components/graphql";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";

export const useReactBlockPageFromRoute = () => {
    const history = useHistory();
    const { query, options } = GET_ALL_MENU_PARAMS();

    const { data: menu } = useQuery<GraphQLResponse<MenuEntity[]>>(query, options);

    const pathname = history?.location?.pathname;
    const front = pathname != null && pathname.trim() === "/" ? true : false;

    const menuEntity = menu?.result?.find(
        d => d != null && pathname != null && d?.enabled === true && d?.link?.url?.path?.trim() === pathname.trim()
    );

    const nodeId =
        menuEntity?.link?.uri?.indexOf("entity:node") > -1 ? menuEntity?.link?.uri?.split("/")?.[1]?.trim() : undefined;
    const id = front ? undefined : nodeId;

    const { query: blockPageQuery, options: blockPageOptions } = GET_REACT_BLOCK_PAGE_PARAMS(front, id);
    const { loading, data, error } = useQuery<unknown>(blockPageQuery, blockPageOptions);

    const newData: GraphQLResponse<ReactBlockPageEntity[]> =
        data == null
            ? data
            : front === true
            ? (data as GraphQLResponse<ReactBlockPageEntity[]>)
            : {
                  result: [(data as GraphQLResponse<ReactBlockPageEntity>).result]
              };

    return {
        loading,
        data: newData,
        error
    };
};
